import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getEstadoCivil, cadastrarEstadoCivil, alterarEstadoCivil, excluirEstadoCivil } from '../../../api';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
var EstadosCivisEditar = function () {
    var services = {
        getItem: getEstadoCivil,
        cadastrarItem: cadastrarEstadoCivil,
        alterarItem: alterarEstadoCivil,
        excluirItem: excluirEstadoCivil,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.ESTADOS_CIVIS, paginaPermissao: FUNCIONALIDADES.ESTADOS_CIVIS, rota: ROUTES.ESTADOS_CIVIS, services: services });
};
export default EstadosCivisEditar;
